import React from "react";
import {
  Box,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { BEDROOMS, WC, MISCELLANEOUS, EXTERIOR } from "./jobprint_constant";
import logoIcon from "../../../assets/images/trunk_1.png";

const FullPackCheckSheet = () => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedSummary } = useSelector((state: any) => state.leadSurvey);

  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
        fontSize: "13px",
      }}
    >
      {/* HEADER */}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <img
            src={leadDetails?.company?.logo ?? logoIcon}
            alt="Trunk Logo"
            style={{ height: "50px" }}
          />
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>Customer:</Typography>
          {leadDetails?.lead?.customer_name}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>Date:</Typography>
          {surveyedSummary?.lead?.movingOnDate
            ? dayjs(surveyedSummary?.lead?.movingOnDate)?.format("DD/MM/YYYY")
            : leadDetails?.lead?.moving_on_date
              ? dayjs(leadDetails?.lead?.moving_on_date)?.format("DD/MM/YYYY")
              : "N/A"}
        </Grid>
      </Grid>

      <Box mt={3}>
        <Typography
          fontWeight="bold"
          align="center"
          style={{ textDecoration: "underline" }}
        >
          PACKING SERVICE – ON ARRIVAL
        </Typography>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: 600 }}>
            Removal team contacted me with an estimated time of arrival -
          </Typography>
          <Box display="flex" gap={3}>
            <FormControlLabel
              control={<Checkbox size="small" />}
              label="Yes"
              labelPlacement="start"
            />

            <FormControlLabel
              control={<Checkbox size="small" />}
              label="No"
              labelPlacement="start"
            />
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography sx={{ fontWeight: 600 }}>
            Removal team reminded me to put aside to avoid packing -
          </Typography>
          <Box display="flex" gap={3}>
            <FormControlLabel
              control={<Checkbox size="small" />}
              label="Yes"
              labelPlacement="start"
            />

            <FormControlLabel
              control={<Checkbox size="small" />}
              label="No"
              labelPlacement="start"
            />
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: 600 }}>Valueables Kit</Typography>
          <Typography sx={{ fontWeight: 600 }}>Medication</Typography>
          <Typography sx={{ fontWeight: 600 }}>Documents</Typography>
          <Typography sx={{ fontWeight: 600 }}>Keys</Typography>
          <Typography sx={{ fontWeight: 600 }}>Overnight</Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} sx={{ fontStyle: "italic" }}>
            Please inspect your property to make sure that all items have been
            packed to your satisfaction before we leave the property.
            <b>
              {" "}
              Any contents we are leaving for you to be packed must be taken
              note of below.
            </b>{" "}
            We prefer that you walk through the residence with the crew leader
            during inspection and sign in the areas below.
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} sx={{ lineHeight: 1 }}>
            <Checkbox /> <b> RELEASE:</b> I have chosen not to inspect my
            residence with the crew leader and understand this will be performed
            by the crew leader on my behalf. I release <b>Trunk Logistics</b>{" "}
            from all liability.
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <Checkbox /> <b> CUSTOMER NOT PRESENT:</b> Customer not available to
            check property. All areas of the property checked by Trunk Crew.
            Checked by
          </Typography>
        </Box>

        <hr style={{ margin: "8px 0px" }} />

        <Box mt={1} display="flex" alignItems="center" justifyContent="center">
          <Typography mr={1} style={{ textDecoration: "underline" }}>
            <b>CHECKLIST</b>
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            If NO, please describe the contents left and take photos(s):
          </Typography>
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            Please sign and date after all relevant sections of this form have
            been completed:
          </Typography>
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Customer:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Date:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Time:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Crew leader:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Date:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Time:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} style={{ textDecoration: "underline" }}>
            <b>INTERIOR</b>
          </Typography>
        </Box>
        {/* bedrooms */}
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <b>Bedrooms</b>
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {BEDROOMS.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={4} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={8} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        {/* W/Cs */}
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <b>W/Cs</b>
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {WC.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={4} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={8} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        {/* Miscellaneous */}
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <b>Miscellaneous</b>
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {MISCELLANEOUS.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={4} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={8} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            If NO, please describe the contents left and take photos(s):
          </Typography>
        </Box>
        <hr style={{ margin: "8px 0px 16px" }} />
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            Please sign and date after all relevant sections of this form have
            been completed:
          </Typography>
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Customer:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Date:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Time:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Crew leader:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Date:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Time:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
        {/* EXTERIOR */}
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} style={{ textDecoration: "underline" }}>
            <b>EXTERIOR</b>
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {EXTERIOR.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={4} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={8} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default FullPackCheckSheet;
